import axios from "axios";
const BASE_URL = import.meta.env.VITE_BASE_URL;
import store from "@/src/store";

export class ApiBase {
    constructor() {
        this.key = null;
    }

    async #baseCall(method, url, data = {}) {
        const key = this.key;
        let params = [`${BASE_URL}/${url}`];
        if (method !== "get" && method !== "delete") {
            params.push(data);
        }
        params.push({
            withCredentials: true,
        });
        store.commit("setLoading", { key, value: true });
        store.commit("setError", null);
        try {
            const res = await axios[method](...params);
            store.commit("setLoading", { key, value: false });
            return res.data;
        } catch (e) {
            store.commit("setError", this.ensureRightErrorObject(e));
            store.commit("setLoading", { key, value: false });
            throw e;
        }
    }

    ensureRightErrorObject(error) {
        if (error.response && error.response.headers["content-type"]?.includes("html")) {
            error = {
                code: "ERR_WRONG_ERROR_TYPE_HTML",
                originalError: error,
            };
        }
        return error;
    }

    async httpPost(url, data) {
        return this.#baseCall("post", url, data);
    }

    async httpGet(url) {
        return this.#baseCall("get", url);
    }

    async httpPut(url, data) {
        return this.#baseCall("put", url, data);
    }

    async httpPatch(url, data) {
        return this.#baseCall("patch", url, data);
    }

    async httpDelete(url) {
        return this.#baseCall("delete", url);
    }

    async exec(method, params) {
        this.key = method;
        if (!this[method]) {
            console.log(method + " NOT IMPLEMENTED");
            return;
        }
        return await this[method](params);
    }
}
